var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridPlaceholder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1234_63045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 149,
    height: 149
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1234_63045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-146 149L3.35889 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.141 149L12.2183 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.282 149L21.0767 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.423 149L29.936 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-110.564 149L38.7944 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.705 149L47.6538 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.8467 149L56.5122 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-83.9873 149L65.3716 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.1289 149L74.23 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.2695 149L83.0894 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.4111 149L91.9478 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.5518 149L100.807 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.6934 149L109.666 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.834 149L118.525 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.9756 149L127.383 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.1162 149L136.243 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.25781 149L145.101 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60156 149L153.96 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.46 149L162.819 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3193 149L171.678 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1777 149L180.537 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0371 149L189.396 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8955 149L198.254 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7549 149L207.114 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6133 149L215.972 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4727 149L224.832 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3311 149L233.69 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1904 149L242.549 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.049 149L251.408 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.908 149L260.267 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.767 149L269.125 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.626 149L277.985 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.484 149L286.843 -4.2538e-05",
    stroke: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.344 149L295.703 -4.2538e-05",
    stroke: "#6C6C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPlaceholder1);
export default __webpack_public_path__ + "static/media/grid-placeholder-1.ecac61d84ef67c4a67e6888f20f73fe5.svg";
export { ForwardRef as ReactComponent };